var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[_c('transition',{attrs:{"enter-active-class":"animated_fadeIn fade_in_page","leave-active-class":"animated_fadeOut fade_out_page"}},[_c('router-view')],1),_vm._v(" "),_c('PopSubmit'),_vm._v(" "),_c('PopCompanyDetail'),_vm._v(" "),_c('PopSubmitResult')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe155228","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 